import { supabase } from '../lib/supabase';

// ===== UNIFIED SEARCH SERVICE =====

function sanitizeQuery(input) {
  if (!input || typeof input !== 'string') return '';
  return input.replace(/[%_(),.'"\\]/g, '').trim().substring(0, 100);
}

export async function searchAll(query) {
  const safe = sanitizeQuery(query);
  if (!safe) return { people: [], posts: [], communities: [] };

  const [peopleRes, postsRes, communitiesRes] = await Promise.all([
    supabase
      .from('profiles')
      .select('id, name, headline, avatar, department')
      .or(`name.ilike.%${safe}%,headline.ilike.%${safe}%,department.ilike.%${safe}%`)
      .limit(5),
    supabase
      .from('posts')
      .select(`
        id, content, created_at, type,
        author:profiles!author_id(id, name, avatar)
      `)
      .ilike('content', `%${safe}%`)
      .order('created_at', { ascending: false })
      .limit(5),
    supabase
      .from('communities')
      .select('id, name, description, avatar')
      .or(`name.ilike.%${safe}%,description.ilike.%${safe}%`)
      .limit(3),
  ]);

  return {
    people: peopleRes.data || [],
    posts: postsRes.data || [],
    communities: communitiesRes.data || [],
  };
}
